import * as React from 'react';
const SvgArrowGray = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 14, height: 9, fill: "none" }, props),
    React.createElement("path", { fill: "#1A0A14", fillRule: "evenodd", d: "M6.884 5.98 1.26.5 0 1.793 6.884 8.5l6.884-6.707L12.508.5 6.884 5.98Z", clipRule: "evenodd" })));
export default SvgArrowGray;
